import script from "./Page.vue?vue&type=script&setup=true&lang=ts"
export * from "./Page.vue?vue&type=script&setup=true&lang=ts"

import "./Page.vue?vue&type=style&index=0&id=d5c78d18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c78d18"]])

export default __exports__